module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/sola_plan_show_bg_03-a555afba73945413052b36dc0ccc6c62.jpg";